<template>
    <div
        class="@container/mh-sidebar flex-1 min-h-0 max-h-full flex flex-col overflow-clip rounded-2xl border-x-0 border-t-0 border-b border-b-white md:bg-slate-300/30 md:shadow-[inset_0px_2px_4px_0px_rgba(0,0,0,0.06)] md:border-solid"
    >
        <div class="scroll-thin flex-auto overflow-auto">
            <div class="flex flex-col p-4 gap-4">
                <intelligent-inbox-section
                    v-for="section in sections"
                    :key="section.state"
                    :section="section"
                    :threads="threadsByCategory"
                ></intelligent-inbox-section>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import IntelligentInboxSection from './IntelligentInboxSection.vue';
import { SAMPLE_THREADS, useIntelligentInbox, type IntelligentThread } from './useIntelligentInbox';

const { sections } = useIntelligentInbox();

const threadsByCategory = computed<Record<string, IntelligentThread[]>>(() => {
    const map: Record<string, IntelligentThread[]> = {};
    for (const section of sections.value) {
        for (const category of section.categories) {
            if (!(category.id in map)) {
                map[category.id] = SAMPLE_THREADS;
            }
        }
    }
    return map;
});
</script>
